import { useTheme } from '@emotion/react';
import { Cancel } from '@mui/icons-material';
import {
  Box,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const ALL = 'all';

const MultiSelectItem = ({ selectedItems, onDelete, allOptionText, sufix }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {selectedItems.includes(ALL) ? (
        <Typography>{allOptionText}</Typography>
      ) : (
        <Chip
          size="small"
          onDelete={onDelete}
          deleteIcon={<Cancel onMouseDown={event => event.stopPropagation()} />}
          label={`${selectedItems.length} ${sufix}`}
        />
      )}
    </Box>
  );
};

export default function MultiSelectFilter({
  currentFilters,
  itemFilter,
  onFilter,
  options,
  menuItemGetter,
  inputLabel,
  sufix,
  hide,
}) {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation('orders');

  if (hide) return null;

  const handleMultiSelect = e => {
    const selectedItems = [...e.target.value];

    if (
      currentFilters[itemFilter].includes(ALL) &&
      selectedItems.includes(ALL)
    ) {
      onFilter({
        ...currentFilters,
        [itemFilter]: selectedItems.filter(item => item !== ALL),
      });
      return;
    }

    if (
      !currentFilters[itemFilter].includes(ALL) &&
      selectedItems.includes(ALL)
    ) {
      onFilter({
        ...currentFilters,
        [itemFilter]: [ALL],
      });
      return;
    }

    onFilter({
      ...currentFilters,
      [itemFilter]: selectedItems,
    });
  };

  const propsByScreenSize = {
    true: {
      flexBasis: '100%',
      width: '100%',
    },
    false: {
      flexBasis: 0,
      width: 'unset',
    },
  };

  return (
    <Stack flexGrow={1} {...propsByScreenSize[smallScreen]}>
      <FormControl fullWidth size="small">
        <InputLabel id={`${itemFilter}-label`}>{inputLabel}</InputLabel>
        <Select
          sx={{
            bgcolor: 'background.paper',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.divider,
            },
          }}
          value={currentFilters[itemFilter]}
          onChange={handleMultiSelect}
          variant="outlined"
          label={inputLabel}
          multiple
          labelId={`${itemFilter}-label`}
          renderValue={() => (
            <MultiSelectItem
              selectedItems={currentFilters[itemFilter]}
              onDelete={() => {
                onFilter({
                  ...currentFilters,
                  [itemFilter]: [ALL],
                });
              }}
              allOptionText={t('orders:vendorsFilter.mainOption')}
              sufix={sufix}
            />
          )}
        >
          <MenuItem value="all">
            {t('orders:vendorsFilter.mainOption')}
          </MenuItem>
          <Divider />
          {options?.map(menuItemGetter)}
        </Select>
      </FormControl>
    </Stack>
  );
}
